import React from 'react';
import screenshootImage from '../img/screenshoot.png';

const Image = () => {
    return (
        <div className="image-wrapper">
            <img src={screenshootImage} className="screenshoot-image"></img>
        </div>
    );
}

export default Image;